{
  "familyId": "SWW-TT-DSTAM",
  "questions": [
    {
      "id": "SWW-TT-DSTAM-001",
      "familyId": "SWW-TT-DSTAM",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_d_stam",
      "questionType": "multiple_choice",
      "question": "Een corrector controleert zinnen. Welke zin bevat een dt-fout?",
      "options": ["Hij word steeds beter.", "Zij wordt steeds beter.", "Ik word steeds beter.", "Wij worden steeds beter."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D-stam Regel", "content": "Als de stam eindigt op -d, schrijf je bij hij/zij: d + t = dt. Check: zet in ik-vorm (ik word) of maak langer (worden).", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_error_recognition",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.inversie-d-stam-t-blijft", "label": "Bij hij/zij -t weggelaten na d-stam", "optionIndex": 0 },
          { "id": "sww.dt-overgeneralize", "label": "dt onterecht gezien als fout", "optionIndex": 1 },
          { "id": "sww.ik-vorm-met-t", "label": "Onnodig -t bij ik-vorm verwacht", "optionIndex": 2 }
        ]
      },
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De corrector ziet het meteen: 'Hij word' mist de -t. De stam van 'worden' is 'word' (eindigt op d). Bij hij/zij/het voeg je -t toe: word + t = wordt (dt). Check: 'ik word' (geen t) → 'hij wordt' (wel t).",
        "solutionSteps": ["Stam van 'worden' = 'word' (eindigt op d)", "Bij hij/zij/het: stam + t = wordt (dt)", "'Hij word' mist de -t → moet 'wordt' zijn"],
        "distractorExplanations": {
          "0": "Goed! 'Hij word' is fout — het moet 'Hij wordt' zijn (d + t = dt).",
          "1": "Je dacht waarschijnlijk dat 'dt' altijd fout is. Maar bij hij/zij/het is dt juist: word + t = wordt. Onthoud: dt is correct bij hij/zij/het als de stam op d eindigt.",
          "2": "Je dacht waarschijnlijk dat 'ik' ook -t krijgt. Maar bij 'ik' gebruik je alleen de stam: ik word (zonder t). Onthoud: ik-vorm = alleen de stam.",
          "3": "Je dacht waarschijnlijk dat meervoud ook dt krijgt. Maar bij wij/jullie/zij gebruik je -en: worden. Onthoud: meervoud = stam + en."
        }
      }
    },
    {
      "id": "SWW-TT-DSTAM-002",
      "familyId": "SWW-TT-DSTAM",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_d_stam",
      "questionType": "text_highlight",
      "question": "Een redacteur zoekt fouten. Klik op het woord met een dt-fout:",
      "context": "Hij word steeds beter in rekenen.",
      "options": [],
      "correctAnswer": 1,
      "data": { "text": "Hij word steeds beter in rekenen.", "correctHighlights": [{"start": 4, "end": 8}] },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D-stam Regel", "content": "De stam 'word' eindigt op d. Bij hij: d + t = dt → 'wordt'. Check: ik word (geen t) → hij wordt (wel t).", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_error_text_highlight",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De redacteur vindt de fout: 'word' moet 'wordt' zijn. De stam van 'worden' is 'word' (eindigt op d). Bij hij: word + t = wordt (dt). Check: 'ik word' (geen t) → 'hij wordt' (wel t).",
        "solutionSteps": ["Stam: word (eindigt op d)", "Bij hij: word + t = wordt", "'word' → 'wordt'"],
        "distractorExplanations": { "1": "Goed! 'Word' moet 'wordt' zijn — dt-regel: stam op d + t = dt." }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.inversie-d-stam-t-blijft", "label": "Bij hij + d-stam -t weggelaten" }
        ]
      }
    },
    {
      "id": "SWW-TT-DSTAM-003",
      "familyId": "SWW-TT-DSTAM",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_d_stam",
      "questionType": "multiple_choice",
      "question": "Staat er een dt-fout in deze zin? 'Ik vind dat hij gelijk heeft.'",
      "options": ["Nee, de zin is helemaal goed", "Ja, 'vind' moet 'vindt' zijn", "Ja, 'heeft' moet 'heefd' zijn", "Ja, 'hij' krijgt een werkwoord met -dt"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D-stam bij ik-vorm", "content": "Bij 'ik' gebruik je alleen de stam (geen t). De stam van 'vinden' is 'vind', dus: ik vind (NIET ik vindt). Loop-check: 'ik loop' (zonder -t) → dus ook 'ik vind' (zonder -t).", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_error_ik_form",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De zin is helemaal goed! 'Ik vind' is juist — bij 'ik' gebruik je alleen de stam (zonder -t). Loop-check: 'ik loop' (zonder -t) → dus ook 'ik vind' (zonder -t). Pas bij 'hij/zij/het' komt er een -t bij: 'hij vindt'.",
        "solutionSteps": [
          "Stam van 'vinden' = 'vind' (eindigt op d)",
          "Bij 'ik': alleen de stam → ik vind (zonder t)",
          "Loop-check: 'ik loop' → geen -t, dus ook 'ik vind' → geen -t",
          "Conclusie: de zin is correct"
        ],
        "distractorExplanations": {
          "0": "Goed! De zin is correct. Bij 'ik' gebruik je alleen de stam: ik vind (zonder -t). Pas bij 'hij/zij/het' komt er een -t bij.",
          "1": "Heel logisch dat je dit dacht — 'vind' eindigt op een d. Maar bij 'ik' gebruik je alleen de stam, zonder -t. Loop-check: 'ik loop' (geen -t), dus ook 'ik vind' (geen -t). Pas bij 'hij/zij/het' wordt het 'vindt'.",
          "2": "'Heeft' is correct geschreven. Het werkwoord 'hebben' is onregelmatig: ik heb, jij hebt, hij heeft. Dat is gewoon zo.",
          "3": "Dit klopt niet — 'hij' krijgt alleen -dt als de stam op d eindigt (vindt, wordt). In deze zin staat geen werkwoord bij 'hij'. 'Hij gelijk heeft' = onderwerp + lijdend voorwerp + 'heeft'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.ik-vorm-met-t", "label": "Bij ik-vorm onnodig -t toegevoegd", "optionIndex": 1 },
          { "id": "sww.onregelmatig-misapplied", "label": "Onregelmatig werkwoord 'hebben' verkeerd herzien", "optionIndex": 2 },
          { "id": "sww.dt-overgeneralize", "label": "Overgeneralisatie van dt-regel", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-DSTAM-004",
      "familyId": "SWW-TT-DSTAM",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_d_stam",
      "questionType": "text_highlight",
      "question": "Een journalist schrijft een artikel. Klik op het woord met een dt-fout:",
      "context": "Zij vind dat hij wordt bedankt.",
      "options": [],
      "correctAnswer": 1,
      "data": { "text": "Zij vind dat hij wordt bedankt.", "correctHighlights": [{"start": 4, "end": 8}] },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D-stam bij zij-vorm", "content": "Bij hij/zij/het voeg je -t toe aan de stam. Stam op d: d + t = dt.\n\n• 'zij vind' → fout! Moet zijn: zij vindt\n• 'hij wordt' → correct (stam 'word' + t)\n• 'bedankt' → correct (voltooid deelwoord)", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_error_zij_form",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Er staan drie woorden met d/t: 'vind', 'wordt' en 'bedankt'. Alleen 'vind' is fout — bij 'zij' hoort: stam + t = vindt. 'Wordt' is correct (hij wordt) en 'bedankt' is een voltooid deelwoord.",
        "solutionSteps": ["Zoek alle woorden met d of t: vind, wordt, bedankt", "Check 'vind': zij + stam vind + t = vindt → FOUT (t ontbreekt)", "Check 'wordt': hij + stam word + t = wordt → correct", "Check 'bedankt': voltooid deelwoord → correct"],
        "distractorExplanations": { "1": "Goed! 'Vind' moet 'vindt' zijn — bij zij voeg je -t toe: vind + t = vindt (dt). De andere woorden (wordt, bedankt) zijn correct." }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.inversie-d-stam-t-blijft", "label": "Bij zij + d-stam -t weggelaten" },
          { "id": "sww.dt-overgeneralize", "label": "Voltooid deelwoord aangezien voor dt-fout" }
        ]
      }
    },
    {
      "id": "SWW-TT-DSTAM-005",
      "familyId": "SWW-TT-DSTAM",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_d_stam",
      "questionType": "multiple_choice",
      "question": "Een schrijver twijfelt. Welke zin is correct?",
      "options": ["Jij houdt van lezen.", "Jij houd van lezen.", "Jij hout van lezen.", "Jij houden van lezen."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D-stam bij jij-vorm", "content": "De stam van 'houden' is 'houd' (eindigt op d). Bij jij: stam + t = houdt (dt). Let op: 'houd' klinkt als 'hout', maar je schrijft 'd' omdat de stam 'houd' is.", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_jij_form_houden",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De schrijver weet: de stam van 'houden' is 'houd' (eindigt op d). Bij jij: stam + t = houdt (dt). Let op: 'houd' klinkt als 'hout', maar je schrijft 'd' omdat de stam 'houd' is (van 'houden').",
        "solutionSteps": ["Stam bepalen: houden − en = houd", "Bij jij: stam + t = houdt", "'houd' klinkt als 'hout', maar schrijf 'd' (van houden)"],
        "distractorExplanations": {
          "0": "Goed! 'Jij houdt' is correct — stam 'houd' + t = houdt (dt).",
          "1": "Je dacht waarschijnlijk dat jij geen -t krijgt. Maar bij jij (niet omgekeerd) voeg je -t toe: jij houdt. Onthoud: jij + werkwoord = stam + t.",
          "2": "Je dacht waarschijnlijk dat je 'hout' schrijft (met een t). Maar de stam is 'houd' (van houden), niet 'hout' (het materiaal). Onthoud: maak het werkwoord langer → houden → stam = houd.",
          "3": "Je dacht waarschijnlijk dat je de hele stam + en gebruikt. Maar 'houden' is de infinitief, niet de jij-vorm. Bij jij: stam + t = houdt. Onthoud: jij-vorm = stam + t."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.inversie-d-stam-t-blijft", "label": "Bij jij + d-stam -t weggelaten", "optionIndex": 1 },
          { "id": "sww.dt-overgeneralize", "label": "Klank 'hout' i.p.v. stam 'houd' geschreven", "optionIndex": 2 },
          { "id": "sww.heel-ww-ipv-stam", "label": "Hele werkwoord i.p.v. stam+t gebruikt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-DSTAM-006",
      "familyId": "SWW-TT-DSTAM",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_d_stam",
      "questionType": "error_spotting",
      "question": "Vind de dt-fouten in deze zinnen.",
      "correctAnswer": null,
      "data": {
        "text": "Hij vind het leuk om te tekenen. Zij word steeds beter in rekenen. Het kind vindt de puzzel moeilijk.",
        "errors": [
          { "word": "vind", "correction": "vindt", "startIndex": 3, "endIndex": 7, "explanation": "Bij hij/zij/het: stam 'vind' + t = vindt. De d-stam krijgt altijd -t erbij bij de derde persoon." },
          { "word": "word", "correction": "wordt", "startIndex": 36, "endIndex": 40, "explanation": "Bij zij (enkelvoud): stam 'word' + t = wordt. Onthoud: ik word, maar zij wordt." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D-stam regel", "content": "Als de stam eindigt op -d, schrijf je bij hij/zij/het: stam + t = dt. Ik word → hij wordt. Ik vind → zij vindt.", "icon": "lightbulb" } }
      ],
      "conceptId": "dstam_error_spotting",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.inversie-d-stam-t-blijft", "label": "Bij hij/zij + d-stam -t weggelaten" },
          { "id": "sww.dt-overgeneralize", "label": "Overgeneralisatie van dt-regel" }
        ]
      },
      "variantIndex": 6,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Twee fouten: 1) 'Hij vind' moet 'Hij vindt' zijn — stam 'vind' + t = vindt. 2) 'Zij word' moet 'Zij wordt' zijn — stam 'word' + t = wordt. De derde zin is correct: 'Het kind vindt'.",
        "solutionSteps": [
          "Check elk werkwoord met d-stam: staat er -t achter bij hij/zij/het?",
          "'vind' bij 'hij' → vindt (mist de t)",
          "'word' bij 'zij' → wordt (mist de t)"
        ]
      }
    },
    {
      "id": "SWW-TT-DSTAM-007",
      "familyId": "SWW-TT-DSTAM",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_d_stam",
      "questionType": "fill_in",
      "question": "Vul in: Zij ... (worden) steeds handiger met de computer.",
      "correctAnswer": "wordt",
      "data": {
        "acceptedAnswers": ["wordt"],
        "placeholder": "tegenwoordige tijd van worden",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D-stam + t", "content": "Stam van 'worden' = 'word'. Bij zij (enkelvoud): word + t = wordt (dt). Check: ik word (geen t) → zij wordt (wel t).", "icon": "lightbulb" } }
      ],
      "conceptId": "dstam_fill_in_wordt",
      "variantIndex": 7,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Stam van 'worden' = 'word' (eindigt op d). Bij zij (enkelvoud): stam + t = wordt. De dt-combinatie is correct: de d hoort bij de stam, de t is de persoonsuitgang.",
        "solutionSteps": [
          "Bepaal de stam: worden → word",
          "Onderwerp 'zij' (enkelvoud) → stam + t",
          "word + t = wordt"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.inversie-d-stam-t-blijft", "label": "Bij zij + d-stam -t weggelaten" }
        ]
      }
    }
  ]
}